import {
  Box,
  chakra,
  HStack,
  Link,
  LinkBox,
  LinkOverlay,
  LinkProps,
  Stack,
  Tag,
} from '@cardboard-ui/react';
import { InfoIcon } from 'components/icons';
import {
  FolderItemLabel,
  useItemHandleFragment$data,
} from 'components/ItemHandle/hooks/__generated__/useItemHandleFragment.graphql';
import { ListItemMainText } from 'components/ListItem/ListItemMainText';
import { ListItemSecondaryText } from 'components/ListItem/ListItemSecondaryText';
import React, { FC } from 'react';
import { useFeatureFlag } from 'utils/sessionProvider';

type HandleProps = {
  name: React.ReactNode;
  label?: FolderItemLabel;
  pins?: NonNullable<useItemHandleFragment$data['pins']>[0][];
  description?: React.ReactNode;
  icon?: React.ReactElement | boolean;
  rightIcon?: React.ReactElement | null;
  linkProps?: LinkProps | null;
  linkBox?: boolean;
};

export const Handle: FC<HandleProps> = ({
  name,
  icon = true,
  rightIcon,
  description,
  label,
  pins,
  linkBox,
  linkProps,
}) => {
  linkBox = !!linkBox && !!linkProps;
  const Wrapper = linkBox ? LinkBox : Box;
  const variant = 'Large';
  const color = 'blue.500';
  let _icon = <></>;

  if (icon === true) {
    _icon = <InfoIcon variant={variant} color={color} />;
  } else if (!icon) {
    // noop
  } else {
    const givenColor = icon.props.color;
    _icon = React.cloneElement(icon, {
      variant,
      color: givenColor || color,
    });
  }

  const shouldUsePins = useFeatureFlag(
    'FEATURE_EVENT_AGENDA_AND_MINUTES_AS_PINS',
  );

  return (
    <Wrapper overflow="hidden" flexGrow={2}>
      <HStack spacing={4} minWidth={0} flexGrow={1} whiteSpace="nowrap">
        <Box>{_icon}</Box>
        <Stack spacing={0} whiteSpace="nowrap" minWidth={0} flexGrow="1">
          {linkBox ? (
            <LinkOverlay as={Link} {...linkProps}>
              <ListItemMainText>
                {name} {rightIcon}
              </ListItemMainText>
            </LinkOverlay>
          ) : (
            <ListItemMainText>
              {name} {rightIcon}
            </ListItemMainText>
          )}

          <ListItemSecondaryText>
            <HStack>
              {description && <chakra.span>{description}</chakra.span>}
              {!shouldUsePins && label && (
                <Tag size="sm" colorScheme="green" data-qa="item-label">
                  {label}
                </Tag>
              )}
              {shouldUsePins && pins?.length
                ? pins.map(({ label, id }) => {
                    return (
                      <Tag
                        key={id}
                        size="sm"
                        colorScheme="green"
                        data-qa="item-label"
                      >
                        {label}
                      </Tag>
                    );
                  })
                : null}
            </HStack>
          </ListItemSecondaryText>
        </Stack>
      </HStack>
    </Wrapper>
  );
};
